<div class="course-page">

    <h1 class="title">All Courses</h1>
    <p class="subtitle">View and manage Courses across all classrooms</p>

    <div class="top-bar">
        <input type="text" class="search-input" placeholder="Search by Course Name" [(ngModel)]="searchText"
            (ngModelChange)="searchCourse(searchText)" />
        <!-- Classroom Filter -->
        <ng-container>
            <!-- Select Dropdown -->
            <div class="select-wrapper" *ngIf="selectedClassroom === 'all'">
                <select class="filter-select" [(ngModel)]="selectedClassroom" (change)="applyFilter()">
                    <option [ngValue]="'all'">All Classrooms</option>

                    <option *ngFor="let c of classrooms" [ngValue]="c.id">
                        {{ c.name }}
                    </option>
                </select>
                <i class="bi bi-chevron-down select-arrow"></i>
            </div>
            <div class="filter-chip" *ngIf="selectedClassroom !== 'all'">
                Classroom: <span>{{ getSelectedClassroomName() }}</span>
                <span class="close-icon" (click)="clearClassroom()">✕</span>
            </div>
        </ng-container>

        <ng-container>
            <!-- Select Dropdown -->
            <div class="select-wrapper" *ngIf="selectedStatus === 'all'">
                <select class="filter-select" [(ngModel)]="selectedStatus" (change)="applyFilter()">
                    <option value="all">Status: All</option>
                    <option value="Published">Published</option>
                    <option value="Draft">Draft</option>
                </select>

                <i class="bi bi-chevron-down select-arrow"></i>
            </div>

            <div class="filter-chip" *ngIf="selectedStatus !== 'all'">
                Status: <span>{{ selectedStatus }}</span>
                <span class="close-icon" (click)="clearStatus()">✕</span>
            </div>
        </ng-container>
    </div>

    <div class="table-card">
        <table class="course-table">
            <thead>
                <tr>
                    <th>S.NO</th>
                    <th>Course Name</th>
                    <th>Classroom</th>
                    <th>Created Date</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
            </thead>

            <tbody>

                <ng-container *ngIf="courses.length > 0; else noData">
                    <tr *ngFor="let q of courses; let i = index">
                        <td>{{ (page - 1) * limit + i + 1 }}</td>
                        <td class="course-name">{{ q.course_title ||'Generating course title…'}}</td>
                        <td>{{ q.classroom || '' }}</td>
                        <td>{{ q.created_date | date: 'mediumDate' }}</td>

                        <td>
                           <span class="status-badge" 
                           [ngClass]="{
                            'published': q.status === courseStatusEnum.Published,
                            'draft': q.status === courseStatusEnum.Draft,
                            'in-progress': q.status === courseStatusEnum.In_Progress }">
							{{ q.status }}</span>
                        </td>

                        <td>
                            <button class="btn-add" (click)="viewCourse(q)"[disabled]="q.status === courseStatusEnum.In_Progress">
                                View
                            </button>
                        </td>
                    </tr>
                </ng-container>

                <ng-template #noData>
                    <tr>
                        <td colspan="6">
                            <div class="empty-row">No courses found for selected filters</div>
                        </td>
                    </tr>
                </ng-template>
            </tbody>
        </table>

        <p-paginator [rows]="limit" [totalRecords]="totalRecords" [rowsPerPageOptions]="[5, 10, 20, 30, 40, 50, 100]"
            (onPageChange)="onPageChange($event)">
        </p-paginator>
    </div>
</div>